































import { Component, Vue } from "vue-property-decorator";
import Header from "@/components/header/MHeader.vue";
import Footer from "@/components/Footer.vue";

@Component({
  components: {
    Header,
    Footer,
  },
})
export default class MPreRegisterComp extends Vue {}
